exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".altModal.modal{display:block}.altModal.modal .modal-header{padding:5px;border-bottom:1px solid #ddd;margin-bottom:0}.altModal.modal .modal-header h2{margin:0;text-align:center;border-bottom:none}.altModal.modal .modal-dialog{max-width:100%}.altModal.modal.slightlyNarrowModal .modal-dialog{width:500px}.altModal.modal.halfWidth .modal-dialog{width:300px}.altModal.modal.twoThirdsWidth .modal-dialog{width:400px}.altModal.modal.twoThirdsWidth .studentSurveyContainer img{width:50%;margin-right:15px}.altModal.modal.wideModal .modal-dialog{width:700px}.altModal.modal.moreWideModal .modal-dialog{width:900px!important}.altModal.modal.veryWideModal .modal-dialog{width:1100px}.altModal.modal .modal-footer{border-top:none;padding-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/alt_modal.scss
// module id = 1457
// module chunks = 0